import { render, staticRenderFns } from "./ClientsVueContainer.vue?vue&type=template&id=0f220094&scoped=true"
import script from "./ClientsVueContainer.vue?vue&type=script&lang=js"
export * from "./ClientsVueContainer.vue?vue&type=script&lang=js"
import style0 from "./ClientsVueContainer.vue?vue&type=style&index=0&id=0f220094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f220094",
  null
  
)

export default component.exports